import React, { Component } from 'react'

import cn from 'classnames'
import s from './Pagination.scss'
import sLay from 'styles/modules/layout.scss'

import IconChevronDown from 'components/Icons/ChevronDown'

export default class Pagination extends Component {
  getItems = () => {
    const { page, numPages } = this.props
    const items = [1]
    if (page - 1 > 1) items.push(page - 1)
    if (page !== 1 && page !== numPages) items.push(page)
    if (page + 1 < numPages) items.push(page + 1)
    if (!items.includes(numPages)) {
      items.push(numPages)
    }
    // We now have an array that includes:
    // - current page +/- 1
    // - first page
    // - last page
    // We add a null when there is a skip of more than 1 integer (this will be a separator)
    return items.reduce((accum, val, idx) => {
      const valCur = val
      const valPre = items[idx - 1]
      if (!valPre || valCur - valPre === 1) {
        // If there is a difference of 1...
        accum.push(valCur)
      } else {
        // Else, we need a seprator
        accum.push(null)
        accum.push(valCur)
      }
      return accum
    }, [])
  }
  onClick = val => {
    const { onClick, page } = this.props
    if (val === 'prev') {
      onClick(page - 1)
    } else if (val === 'next') {
      onClick(page + 1)
    } else if (val !== page) {
      onClick(val)
    }
  }
  render() {
    const { page, numPages } = this.props
    const items = this.getItems()
    return (
      <div className={cn(sLay['layout-row'], sLay['layout-align-center-center'], s.paginator)}>
        <a
          className={cn(s.button, s.left)}
          disabled={page === 1}
          onClick={() => this.onClick('prev')}
        >
          <IconChevronDown />
        </a>
        {items.map((item, idx) => {
          if (item === null) {
            return (
              <div
                key={idx}
                className={cn(sLay['layout-row'], sLay['layout-align-center-center'], s.separator)}
              >
                <span />
                <span />
                <span />
              </div>
            )
          }
          return (
            <a
              key={idx}
              onClick={() => this.onClick(item)}
              className={cn(s.page, { [s.active]: item === page })}
            >
              {item}
            </a>
          )
        })}
        <a
          className={cn(s.button, s.right)}
          disabled={page === numPages}
          onClick={() => this.onClick('next')}
        >
          <IconChevronDown />
        </a>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Pagination/Pagination.jsx